import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as itemTypes from "../../../../constants/itemTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as rccActions from "../../../../actions/rccActions";
import * as barcodeActions from "../../../../actions/barcodeActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";

class SetCanisterUfiCodeModal extends Component {
    constructor(props) {
        super(props);

        if (
            this.props.params.canister === undefined ||
            this.props.params.canister === null ||
            this.props.params.canister.ufi === null
        ) {
            this.state = {
                ufiCode: "",
                isValid: false,
                barcodeUfi: null,
                barcodeReset: false
            };
        } else {
            this.state = {
                ufiCode: this.props.params.canister.ufi,
                isValid: validationHelper.isUfiCodeValid(this.props.params.canister.ufi),
                barcodeUfi: null,
                barcodeReset: false
            };
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.barcodeType === itemTypes.UFI_CODE && nextProps.barcode !== prevState.barcodeUfi) {
            if (prevState.barcodeReset) {
                return {barcodeReset: false};
            }

            return {
                ufiCode: nextProps.barcode,
                isValid: validationHelper.isUfiCodeValid(nextProps.barcode),
                barcodeUfi: nextProps.barcode
            };
        }

        return null;
    }

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleUfiCodeChange = (event) => {
        if (event.target.value.length < 20) {
            if (this.state.barcodeUfi !== null) {
                this.setState(
                    {
                        ufiCode: event.target.value,
                        isValid: validationHelper.isUfiCodeValid(event.target.value),
                        barcodeUfi: null,
                        barcodeReset: true
                    },
                    this.props.dispatchResetBarcodeAction
                );
            } else {
                this.setState({
                    ufiCode: event.target.value,
                    isValid: validationHelper.isUfiCodeValid(event.target.value)
                });
            }
        }
    };

    handleConfirmButtonClick = () => {
        if (this.state.isValid) {
            this.props.dispatchSetCanisterUfiCodeAction(this.props.params.canister.id, this.state.ufiCode.trim());
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    getUfiInput = () => {
        return (
            <div className={"dialog-messages " + (this.state.isValid ? "messages-success" : "messages-warning")}>
                <div className="padding-bottom-10">
                    {this.state.isValid ? <span className="glyphicon glyphicon-ok-sign" /> : null}
                    <Translate value="general.ufiCode" />
                </div>
                <Input
                    elementProps={{style: {textAlignLast: "center"}}}
                    className="col-12 text-align-center"
                    type="text"
                    value={this.state.ufiCode}
                    onFocus={this.handleInputFocus}
                    onChange={this.handleUfiCodeChange}
                />
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(<div className="col-12">{this.getUfiInput()}</div>);
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleConfirmButtonClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                    disabled={!this.state.isValid}
                    tooltipText={this.state.isValid ? null : translate("help.ufiCode.invalidUfi")}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.ufiCode" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        barcode: store.barcode.item,
        barcodeType: store.barcode.itemType
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SET_CANISTER_UFI_CODE_MODAL));
        },
        dispatchSetCanisterUfiCodeAction: (index, ufiCode) => {
            dispatch(rccActions.setCanisterUfiCode(index, ufiCode));
        },
        dispatchResetBarcodeAction: () => {
            dispatch(barcodeActions.resetBarcode());
        }
    };
};

export default SetCanisterUfiCodeModal = connect(mapStoreToProps, mapDispatchToProps)(SetCanisterUfiCodeModal);
